import { getUserStsTempByEmail } from "@/services/user-sts-temp.service";

// initial state
const state = () => ({});

// mutations
const mutations = {};

// actions
const actions = {
  //Etkinlik Listesi
  async getUserStsTempByEmail(vuexContext, email) {
    return await getUserStsTempByEmail(email).then((response) => {
      let data = response.data.data;
      return data;
    });
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
